import { render, staticRenderFns } from "./EduDeleteButton.vue?vue&type=template&id=27a901c8&scoped=true"
import script from "./EduDeleteButton.vue?vue&type=script&lang=js"
export * from "./EduDeleteButton.vue?vue&type=script&lang=js"
import style0 from "./EduDeleteButton.vue?vue&type=style&index=0&id=27a901c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a901c8",
  null
  
)

export default component.exports